var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStarFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-V2",
    transform: "translate(-120.000000, -1701.000000)",
    fill: "#FF7800",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(79.500000, 1408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(20.500000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3263091,6.81303601 L9.05447222,6.53951636 L9.05447222,6.53951636 L7.43740447,2.58304945 C7.36311165,2.4012778 7.15553038,2.31414899 6.97375873,2.38844181 C6.8853958,2.42455707 6.81526635,2.49468652 6.77915109,2.58304945 L5.16208333,6.53951636 L5.16208333,6.53951636 L0.894904061,6.81303772 C0.698938316,6.8255989 0.550259542,6.99464337 0.562820724,7.19060912 C0.569093023,7.28846262 0.615497486,7.37938202 0.691061803,7.44186948 L3.95927778,10.1445011 L3.95927778,10.1445011 L2.88432348,14.2537895 C2.83462755,14.4437649 2.94834656,14.638057 3.13832201,14.6877529 C3.23220892,14.7123129 3.33205494,14.6974293 3.41469718,14.6465549 L7.10827778,12.3727922 L7.10827778,12.3727922 L10.8018879,14.6465588 C10.9691106,14.7495002 11.1881218,14.6973899 11.2910632,14.5301673 C11.3419373,14.4475252 11.3568207,14.3476795 11.3322608,14.2537929 L10.2573056,10.1445011 L10.2573056,10.1445011 L13.5299847,7.44202764 C13.6814005,7.31699328 13.7027869,7.09288609 13.5777526,6.94147022 C13.5152574,6.86578898 13.4242579,6.81930753 13.3263091,6.81303601 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarFill);
export default __webpack_public_path__ + "static/media/ic_star_fill.10974931.svg";
export { ForwardRef as ReactComponent };